/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "userLogo",
    class: {
      'border-effect': _vm.showBorderEffect
    },
    style: {
      width: "" + _vm.count,
      height: "" + _vm.count,
      border: _vm.showBorder ? _vm.borderWidth + "px solid " + _vm.borderColor : 'none'
    }
  }, [_vm.flag ? [_c('div', {
    staticClass: "username",
    style: {
      lineHeight: "" + _vm.count,
      fontSize: "" + _vm.font(_vm.size)
    }
  }, [_vm._v(" " + _vm._s(_vm.userName) + " ")])] : [_c('img', {
    attrs: {
      "src": _vm.url,
      "width": "100%",
      "height": "100%"
    }
  })]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };